import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input, Button } from 'semantic-ui-react';

const dividerStyle = {
  height: 10,
  width: '100%',
  display: 'block',
};

const editorStyle = {
  minWidth: 200,
  padding: 5,
};

class TagEditor extends React.Component {
  //
  constructor(props) {
    super(props);
    this.state = {
      initialValue: props.value,
      value: props.value,
    };
  }

  onInputChanged = (event, { value }) => this.setState({
    value,
  })

  render() {
    const { value, initialValue } = this.state;
    const { onSave, onDelete, id } = this.props;
    const isDisabled = _.isEmpty(_.trim(value)) || _.eq(initialValue, value);
    return (
      <div style={editorStyle}>
        <h4>Edit tag</h4>
        <div style={dividerStyle} />
        <Input fluid value={value} onChange={this.onInputChanged} />
        <div style={dividerStyle} />
        <Button.Group widths="two">
          <Button color="grey" onClick={() => onDelete(id)}>Delete</Button>
          <Button
            disabled={isDisabled}
            color="pink"
            onClick={() => onSave(id, value)}
          >Save</Button>
        </Button.Group>
      </div>
    )
    ;
  }
}

TagEditor.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default TagEditor;



/** WEBPACK FOOTER **
 ** ./src/components/tag-editor/index.js
 **/